import * as actionTypes from './actionTypes';

export const onValidateOTPSuccess = response => {
    return {
        type: actionTypes.VALIDATE_OTP_SUCCESS,
        response,
    };
};

export const onValidateOTPFailed = error => {
    return {
        type: actionTypes.VALIDATE_OTP_FAILED,
        error,
    };
};

export const onValidateOTPStart = (Id, otp, applicationDetails, applicantDetails, licenseFiles, employmentFiles) => {
    return {
        type: actionTypes.VALIDATE_OTP,
        sessionId: Id,
        otp,
        applicationDetails,
        applicantDetails,
        licenseFiles,
        employmentFiles,
    };
};
